import clsx from "clsx";
import React from "react";

type Props = {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};

const baseStyle = "rounded flex justify-center items-center h-[24px] w-[36px] transition duration-200 ease-in-out";
const enabledStyle = "bg-[#fff] hover:bg-[#fff8ee] active:bg-[#d5a541]";
const disabledStyle = "bg-gray hover:none active:none";

export const MachineSubmenuSizeButton = ({ onClick, disabled, children }: Props) => {
  return (
    <button className={clsx(baseStyle, disabled ? disabledStyle : enabledStyle)} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};
